
import { Container, Row } from 'react-bootstrap'
import { YWPCreateAccount, Advisors,  Contributors} from '@components/Block'

function Experts(props) {
    return (
        <div className="experts my-lg-5 mt-5 mb-0 text-center">
            <Container>
                <h3 className="text-green"><strong>Curated by Wellness Experts & Scientists</strong></h3>
                <p className="mb-5">Our content is written and curated by experts in various fields of health and wellness.</p>
                <p className="mb-5 h5"><strong>Our nutritional science advisors:</strong></p>
                <div className="advisors mb-5">
                    <Row>
                        <Advisors/>
                    </Row>
                </div>
                <p className="mb-5 h5"><strong>Our expert contributors:</strong></p>
                <div className="contributors">
                    <Row>
                        <Contributors/>
                    </Row>
                </div>
                <YWPCreateAccount site={props.site} bgcolor="bg-green" txtcolor="text-white"/>

            </Container>
            <style jsx global>
                {`
                    .card-title{
                        font-size:1rem;
                    }

                    .advisors .card-text{
                        font-size:.85rem;
                    }

                    @media (max-width:767px){
                        .contributors .col{
                            max-width: 50%;
                            min-width: 50%;
                        }
                    }
                `}
            </style>
        </div>
    )
}

export default Experts
